import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Grid, Stack, TablePagination
} from "@mui/material";
import http from "../../utils/http-common";
import { toast } from "react-toastify";
import { styled } from '@mui/material/styles';
import { Edit as EditIcon, ChangeCircle as ChangeCircleIcon } from '@mui/icons-material';
const StatusButton = styled(Box)(({ status }) => ({
  padding: '2px 8px',
  borderRadius: '20px',
  fontSize: '12px',
  fontWeight: 600,
  backgroundColor: 'transparent',
  border: `1px solid ${getStatusColor(status)}`,
  color: getStatusColor(status),
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '24px',
  minWidth: '90px',
  textTransform: 'capitalize'
}));

// Add this function before your component to get status color
const getStatusColor = (status) => {
  const statusColors = {
    'Open': '#2196F3',        // Blue
    'In Progress': '#FF9800', // Orange
    'Pending': '#FFA726',     // Light Orange
    'Requested': '#666666',   // Gray
    'Schedule': '#9C27B0',    // Purple
    'Technical': '#00ACC1',   // Cyan
    'Completed': '#4CAF50',   // Green
    'Blocked': '#F44336'      // Red
  };
  return statusColors[status] || '#666666'; // Default gray if status not found
};
export default function Dependencies() {
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);

  // Add pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [dependencyModalOpen, setDependencyModalOpen] = useState(false);
  const [dependencyData, setDependencyData] = useState({
    id: "",
    name: "",
    from: "",
    owner: "",
    due_date: new Date().toISOString().split('T')[0],
    status: "Pending"
  });

  const [dependencies, setDependencies] = useState([]);
  const planId = localStorage.getItem("plan_id");
  useEffect(() => {
    fetchPlanData();
  }, [planId]);
  const fetchPlanData = async () => {
    try {
      const response = await http.get(`/master_service/get_project/plan/summary/${planId}`);
      if (response.status === 200) {
        const data = response.data.dependencies.map(item => ({
          id: item.dept_id,
          name: item.name,
          from: item.from,
          owner: item.owner,
          due_date: item.due_date,
          status: item.status
        }));
        setDependencies(data);
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };
  const [filters, setFilters] = useState({
    issues: '',
    assumptions: '',
    risks: '',
    dependencies: '',
    constraints: ''
  });
  const [expandedSections, setExpandedSections] = useState({});
  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };
  const filterDependencies = () => {
    return dependencies.filter(dependency =>
      Object.values(dependency).some(value =>
        value ? value.toString().toLowerCase().includes(filters.dependencies.toLowerCase()) : false
      )
    );
  };
  const handleFilterChange = (table, value) => {
    setFilters(prev => ({
      ...prev,
      [table]: value
    }));
  };
  const handleInputChange3 = (field, value) => {
    setDependencyData(prev => ({ ...prev, [field]: value }));
  };

  const handleEdit = (dependency) => {
    setDependencyData({
      id: dependency.id,
      name: dependency.name,
      from: dependency.from,
      owner: dependency.owner,
      due_date: dependency.due_date,
      status: dependency.status,
    });
    setDependencyModalOpen(true);
  };
  const handleStatusUpdate = async (dependency) => {

    const nextStatus = getNextStatus(dependency.status);
    try {
      const payload = {
        dept_id: dependency.id,
        "name": dependency.name,
        "from": dependency.from,
        "due_date": dependency.due_date,
        "confidence": dependency.confidence,
        "owner": dependency.owner,
        "plan_id": planId,
        status: nextStatus,
      };
      const response = await http.post('/master_service/create_update/dependency', payload);
      if (response.status === 200 || response.status === 201) {
        toast.success("Status updated successfully");
        fetchPlanData();
      }
    } catch (error) {
      toast.error("Failed to update status");
    }
  };

  // Helper function to determine next status
  const getNextStatus = (currentStatus) => {
    const statusFlow = {
      'Open': 'Pending',
      'Pending': 'Requested',
      'Requested': 'Confirmed',
      'Confirmed': 'Open',
    };
    return statusFlow[currentStatus] || 'Open';
  };

  const handleSave = async (data, closeModal, resetData) => {
    try {
      const payload = {
        dept_id: data.id,
        plan_id: planId,
        "name": data.name,
        "from": data.from,
        "owner": data.owner,
        "due_date": data.due_date,
        "status": data.status
      }
      const response = await http.post('/master_service/create_update/dependency', payload);
      if (response.status === 201 || response.status === 200) {
        toast.success("Data saved successfully");
        closeModal(false);
        resetData();
        fetchPlanData();
      }
    } catch (error) {
      toast.error("Failed to save data1");
    }
  };
  return (
    <Container maxWidth={false} sx={{ width: "100%", p: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', bgcolor: '#F7F8F8', p: 0.5, mb: 0.2 }}>
        <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
          <Typography style={{ fontWeight: "600" }}>Dependencies (Receivables)</Typography>
          <Typography sx={{ ml: 1, fontSize: '12px' }}>({dependencies.length} Dependencies)</Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
          <TextField
            size="small"
            placeholder="Search here..."
            value={filters.dependencies}
            onChange={(e) => handleFilterChange('dependencies', e.target.value)}
            sx={{ ml: 2, mr: 1, minWidth: '200px' }}
          /><Button
            onClick={() => setDependencyModalOpen(true)}
            sx={{
              minWidth: '24px',
              width: '26px',
              height: '26px',
              p: 0,
              mr: '4px',
              color: '#FFF',
              border: 'none',
              backgroundColor: '#FF2800',
              '&:hover': {
                backgroundColor: '#FF2800',
                border: 'none'
              }
            }}
          >
            +
          </Button>
        </Box>
      </Box>
      <TableContainer component={Paper} sx={{ mb: 3 }}>
        <Table size="small">
          <TableHead sx={{ backgroundColor: "#e0eaff" }}>
            <TableRow sx={{ '& .MuiTableCell-head': { py: 0.1, fontSize: '12px', fontWeight: 500 } }}>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>From</TableCell>
              <TableCell>Owner</TableCell>
              <TableCell>Due Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filterDependencies().slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((dependency, index) => (
                <TableRow key={index} sx={{ '& .MuiTableCell-body': { py: 0.2 } }}>
                  <TableCell>{dependency.id}</TableCell>
                  <TableCell>{dependency.name}</TableCell>
                  <TableCell>{dependency.from}</TableCell>
                  <TableCell>{dependency.owner}</TableCell>
                  <TableCell>{dependency.due_date}</TableCell>
                  <TableCell><StatusButton status={dependency.status}>{dependency.status}</StatusButton></TableCell>
                  <TableCell>
                    <Stack direction="row" spacing={1}>
                      <IconButton
                        size="small"
                        onClick={() => handleEdit(dependency)}
                        sx={{ p: 0.5 }}
                      >
                        <EditIcon sx={{ height: "18px", width: "18px", color: "#666" }} />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => handleStatusUpdate(dependency)}
                        sx={{ p: 0.5 }}
                      >
                        <ChangeCircleIcon sx={{ height: "18px", width: "18px", color: getStatusColor(dependency.status) }} />
                      </IconButton>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        {filterDependencies().length > 10 && (
          <TablePagination
            rowsPerPageOptions={[10]}
            component="div"
            count={filterDependencies().length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            sx={{
              '.MuiTablePagination-toolbar': {
                minHeight: '40px',
              },
              '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                fontSize: '12px',
              }
            }}
          />
        )}
      </TableContainer>
      <Modal
        open={dependencyModalOpen}
        onClose={() => setDependencyModalOpen(false)}
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-end"
        }}
      >
        <Box
          sx={{
            width: "350px",
            height: "100%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 1,
            overflowY: "auto",
            '& .MuiInputBase-input': { // Add this style to reduce input font size
              fontSize: '0.875rem'
            },
            '& .MuiInputLabel-root': { // Add this style to reduce label font size
              fontSize: '0.875rem'
            },
            '& .MuiMenuItem-root': { // Add this style to reduce dropdown item font size
              fontSize: '0.875rem'
            }
          }}
        >
          <Typography mb={1.5} style={{ font: 'bold', fontWeight: '600' }}>Add Dependency</Typography>

          <TextField
            fullWidth
            label="Name"
            value={dependencyData.name}
            onChange={(e) => {
              const newValue = e.target.value;
              handleInputChange3("name", newValue);
            }}
            sx={{ mb: 1.5 }}
            size="small"
          />

          <TextField
            fullWidth
            label="From"
            value={dependencyData.from}
            onChange={(e) => handleInputChange3("from", e.target.value)}
            sx={{ mb: 1.5 }}
            size="small"
          />

          <TextField
            fullWidth
            label="Owner"
            value={dependencyData.owner}
            onChange={(e) => {
              const newValue = e.target.value;
              handleInputChange3("owner", newValue);
            }}
            sx={{ mb: 1.5 }}
            size="small"
          />

          <TextField
            fullWidth
            type="date"
            label="Due Date"
            value={dependencyData.due_date}
            onChange={(e) => handleInputChange3("due_date", e.target.value)}
            sx={{ mb: 1.5 }}
            InputLabelProps={{
              shrink: true,
            }}
            size="small"
            inputProps={{
              min: new Date().toISOString().split("T")[0]  // ✅ Only allow today & future
            }}
          />

          <FormControl fullWidth sx={{ mb: 1.5 }} size="small">
            <InputLabel id="dependency-status-label" shrink={true}>Status</InputLabel>
            <Select
              labelId="dependency-status-label"
              value={dependencyData.status}
              label="Status"
              onChange={(e) => handleInputChange3("status", e.target.value)}
              notched
            >
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Requested">Requested</MenuItem>
              <MenuItem value="Confirmed">Confirmed</MenuItem>
            </Select>
          </FormControl>

          <Button
            fullWidth
            onClick={() => handleSave(dependencyData, setDependencyModalOpen, () => setDependencyData({
              id: "",
              name: "",
              from: "",
              owner: "",
              due_date: new Date().toISOString().split('T')[0],
              status: "Pending"
            }))}
            sx={{
              textTransform: "none",
              bgcolor: '#FF2800',
              color: 'white',
              mb: 0.5,
              "&:hover": { bgcolor: "#FF2800" }
            }}
          >
            Save
          </Button>

          <Button
            fullWidth
            onClick={() => setDependencyModalOpen(false)}
            sx={{ textTransform: "none", bgcolor: 'white', color: 'black' }}
          >
            Cancel
          </Button>
        </Box>
      </Modal>
    </Container>
  )
}